/**
 * FEATURE_CODES — single source of truth.
 * Every code here maps 1-to-1 with a "code" field in master_outlet_menus.json.
 * Use these constants everywhere: hooks, guards, components.
 * NEVER use raw strings in JSX — always reference FEATURE_CODES.XXX.
 */
export const FEATURE_CODES = {

    // ─── POS ─────────────────────────────────────────────────────────────────
    POS: 'POS',

    // POS › Menu Management  (is_menu: true → nav item, protected by route guard)
    MENU_MANAGEMENT: 'POS_MENU_MANAGEMENT',

    // POS › Menu Management › sub-features  (is_menu: false → button / action level)
    MANAGE_CATEGORY_SUB_CATEGORY: 'POS_MANAGE_CATEGORY_SUB_CATEGORY',
    ADD_NEW_DISH: 'POS_ADD_NEW_DISH',
    MANAGE_KOT_PRINT: 'POS_MANAGE_KOT_PRINT',
    MARK_AS_OUT_OF_STOCK: 'POS_MARK_AS_OUT_OF_STOCK',
    MANAGE_MENU: 'POS_MANAGE_MENU',

    // POS › Offer Combos
    OFFER_COMBOS: 'POS_OFFER_COMBOS',
    OFFER_COMBO_MANAGEMENT: 'POS_OFFER_COMBO_MANAGEMENT',

    // POS › Table Management
    TABLE_MANAGEMENT: 'POS_TABLE_MANAGEMENT',
    TABLE_MANAGEMENT_ACCESS: 'POS_TABLE_MANAGEMENT_ACCESS',
    TABLE_MANAGEMENT_QRCODE_ACCESS: 'POS_TABLE_MANAGEMENT_QRCODE_ACCESS',

    // POS › Hostess View
    HOSTESS_VIEW: 'POS_HOSTESS_VIEW',
    MANAGE_RESERVATION_HOSTESS_MANAGEMENT: 'POS_MANAGE_RESERVATION_HOSTESS_MANAGEMENT',

    // ─── INVENTORY ───────────────────────────────────────────────────────────
    INVENTORY: 'INVENTORY',
    DASHBOARD: 'INVENTORY_DASHBOARD',
    SUPPLY_CHAIN_MANAGEMENT: 'INVENTORY_SUPPLY_CHAIN_MANAGEMENT',
    MANAGE_EXPIRY_TRACKING: 'INVENTORY_MANAGE_EXPIRY_TRACKING',
    MANAGE_INVENTORY: 'INVENTORY_MANAGE_INVENTORY',
    MANAGE_NEW_STOCK: 'INVENTORY_MANAGE_NEW_STOCK',
    MANAGE_ON_SHELF_PRODUCT: 'INVENTORY_MANAGE_ON_SHELF_PRODUCT',
    PLACE_PURCHASE_ORDER: 'INVENTORY_PLACE_PURCHASE_ORDER',
    MANAGE_ORDER_HISTORY: 'INVENTORY_MANAGE_ORDER_HISTORY',

    PURCHASES: 'INVENTORY_PURCHASES',
    SUPPLY_CHAIN_DASHBOARD: 'INVENTORY_SUPPLY_CHAIN_DASHBOARD',
    INVENTORY_OVERVIEW: 'INVENTORY_INVENTORY_OVERVIEW',


    INVOICING: 'INVENTORY_INVOICING',
    UPLOAD_INVOICE: 'INVENTORY_UPLOAD_INVOICE',
    PAY_INVOICES: 'INVENTORY_PAY_INVOICES',
    MANAGE_ALL_INVOICES: 'INVENTORY_MANAGE_ALL_INVOICES',

    INVENTORY_SUPPLIER_MANAGEMENT: 'INVENTORY_SUPPLIER_MANAGEMENT',
    SUPPLIER_MANAGEMENT: 'INVENTORY_SUPPLIER_MANAGEMENT',
    ADD_VENDOR: 'INVENTORY_ADD_VENDOR',
    MANAGE_ALL_VENDORS: 'INVENTORY_MANAGE_ALL_VENDORS',

    AUTO_ORDERING: 'INVENTORY_AUTO_ORDERING',
    SET_UP_AUTO_ORDER: 'INVENTORY_SET_UP_AUTO_ORDER',
    VIEW_AUTO_ORDER: 'INVENTORY_VIEW_AUTO_ORDER',
    MANAGE_AUTO_ORDER: 'INVENTORY_MANAGE_AUTO_ORDER',

    STOCK_REAL_TIME: 'INVENTORY_STOCK_REAL_TIME',
    MANAGE_CONSUMPTIONS: 'INVENTORY_MANAGE_CONSUMPTIONS',
    MANAGE_SEASONAL_ITEMS: 'INVENTORY_MANAGE_SEASONAL_ITEMS',
    MANAGE_STOCK_RECONCILIATION: 'INVENTORY_MANAGE_STOCK_RECONCILIATION',

    BRANCH_TRANSFER: 'INVENTORY_BRANCH_TRANSFER',
    MANAGE_BRANCH_TRANSFERS: 'INVENTORY_MANAGE_BRANCH_TRANSFERS',
    VIEW_TRANSFERS: 'INVENTORY_VIEW_TRANSFERS',

    WASTE_CANCELLATION_MANAGEMENT: 'INVENTORY_WASTE_CANCELLATION_MANAGEMENT',
    MANAGE_WASTAGE_CANCELLATION_AUDIT_LOG: 'INVENTORY_MANAGE_WASTAGE_CANCELLATION_AUDIT_LOG',
    LOG_WASTAGE: 'INVENTORY_LOG_WASTAGE',
    LOG_CANCELLATION: 'INVENTORY_LOG_CANCELLATION',

    SKU: 'INVENTORY_SKU',
    GENERATE_BAR_CODE: 'INVENTORY_GENERATE_BAR_CODE',
    MANUAL_SKU: 'INVENTORY_MANUAL_SKU',
    MANAGE_ALL_SKUS: 'INVENTORY_MANAGE_ALL_SKUS',

    RECIPES: 'INVENTORY_RECIPES',
    ADD_RECIPES: 'INVENTORY_ADD_RECIPES',
    COST_PROFITABILITY_CALCULATION: 'INVENTORY_COST_PROFITABILITY_CALCULATION',
    MANAGE_RECIPE_LOG: 'INVENTORY_MANAGE_RECIPE_LOG',

    // ─── STAFFING ────────────────────────────────────────────────────────────
    STAFFING: 'STAFFING',
    EMPLOYEE_DIRECTORY: 'STAFFING_EMPLOYEE_DIRECTORY',
    MANAGE_LEAVES: 'STAFFING_MANAGE_LEAVES',
    MANAGE_STAFF_INFO: 'STAFFING_MANAGE_STAFF_INFO',
    VIEW_PERFORMANCE_REVIEWS: 'STAFFING_VIEW_PERFORMANCE_REVIEWS',
    REGULARIZE_TIME_FOR_EMPLOYEES: 'STAFFING_REGULARIZE_TIME_FOR_EMPLOYEES',

    EMPLOYEE_ATTENDANCE: 'STAFFING_EMPLOYEE_ATTENDANCE',

    SHIFT_PLANNING: 'STAFFING_SHIFT_PLANNING',
    STAFF_SCHEDULING: 'STAFFING_STAFF_SCHEDULING',
    STAFF_MANAGEMENT: 'STAFFING_STAFF_MANAGEMENT',
    VIEW_SHIFTS: 'STAFFING_VIEW_SHIFTS',

    STAFF_SETTINGS: 'STAFFING_STAFF_SETTINGS',

    // ─── CRM ─────────────────────────────────────────────────────────────────
    CRM: 'CRM',
    CRM_DASHBOARD: 'CRM_DASHBOARD',

    CUSTOMER_SEGMENTS_PROFILES: 'CRM_CUSTOMER_SEGMENTS_PROFILES',
    MANAGE_CUSTOMER_SEGMENTS_PROFILES: 'CRM_MANAGE_CUSTOMER_SEGMENTS_PROFILES',
    MANAGE_GROUPS: 'CRM_MANAGE_GROUPS',

    MEMBERS_INFO: 'CRM_MEMBERS_INFO',
    VIEW_MEMBER_INFO: 'CRM_VIEW_MEMBER_INFO',
    MANAGE_MEMBER_INFO: 'CRM_MANAGE_MEMBER_INFO',

    CAMPAIGN_CONTROL: 'CRM_CAMPAIGN_CONTROL',
    CREATE_CAMPAIGNS: 'CRM_CREATE_CAMPAIGNS',
    MANAGE_CAMPAIGNS: 'CRM_MANAGE_CAMPAIGNS',

    LOYALTY_REWARDS: 'CRM_LOYALTY_REWARDS',
    MANAGE_LOYALTY_SETTINGS: 'CRM_MANAGE_LOYALTY_SETTINGS',
    MANAGE_LOYALTY_REWARDS: 'CRM_MANAGE_LOYALTY_REWARDS',

    FEEDBACK_RATINGS: 'CRM_FEEDBACK_RATINGS',
    MANAGE_FEEDBACKS: 'CRM_MANAGE_FEEDBACKS',
    REPLY_TO_FEEDBACKS: 'CRM_REPLY_TO_FEEDBACKS',
    SEND_FEEDBACK_REQUESTS_TO_CUSTOMER: 'CRM_SEND_FEEDBACK_REQUESTS_TO_CUSTOMER',

    // ─── FINANCE ─────────────────────────────────────────────────────────────
    FINANCE: 'FINANCE',
    FINANCE_DASHBOARD: 'FINANCE_DASHBOARD',

    PROFIT_ANALYTICS: 'FINANCE_PROFIT_ANALYTICS',
    VIEW_DASHBOARD_PROFIT_ANALYTICS: 'FINANCE_VIEW_DASHBOARD___PROFIT_ANALYTICS',
    VIEW_TOTAL_REVENUE_SUMMARY: 'FINANCE_VIEW_TOTAL_REVENUE_SUMMARY',
    VIEW_GROSS_PROFIT_SUMMARY: 'FINANCE_VIEW_GROSS_PROFIT_SUMMARY',
    VIEW_TOTAL_EXPENSES_SUMMARY: 'FINANCE_VIEW_TOTAL_EXPENSES_SUMMARY',
    VIEW_NET_PROFIT_SUMMARY: 'FINANCE_VIEW_NET_PROFIT_SUMMARY',
    ADD_EXPENSES: 'FINANCE_ADD_EXPENSES',

    INVOICE_COGS_REPORT: 'FINANCE_INVOICE_COGS_REPORT',
    INVOICE_REPORT: 'FINANCE_INVOICE_REPORT',
    MANAGE_INVOICE: 'FINANCE_MANAGE_INVOICE',

    SALES_REPORT: 'FINANCE_SALES_REPORT',
    MANAGE_SALES_REPORTS: 'FINANCE_MANAGE_SALES_REPORTS',

    TAXATION_COMPLIANCE: 'FINANCE_TAXATION_COMPLIANCE',
    MANAGE_TAXABLE_SALES: 'FINANCE_MANAGE_TAXABLE_SALES',
    MANAGE_TOTAL_GST_COLLECTED: 'FINANCE_MANAGE_TOTAL_GST_COLLECTED',
    MANAGE_GST_PAYABLE_THIS_MONTH: 'FINANCE_MANAGE_GST_PAYABLE_THIS_MONTH',
    MANAGE_VAT: 'FINANCE_MANAGE_VAT',
    MANAGE_GST_PAID_YTD: 'FINANCE_MANAGE_GST_PAID_YTD',
    MANAGE_GST_ALERTS: 'FINANCE_MANAGE_GST_ALERTS',
    MANAGE_GSTR_1: 'FINANCE_MANAGE_GSTR_1',
    GSTR_3B: 'FINANCE_GSTR_3B',
    VAT: 'FINANCE_VAT',
    MANAGE_AUDIT_TRAIL_LOG: 'FINANCE_MANAGE_AUDIT_TRAIL_LOG',
    MULTI_OUTLET_VAT_AGGREGATION: 'FINANCE_MULTI_OUTLET_VAT_AGGREGATION',

    TRANSACTIONS: 'FINANCE_TRANSACTIONS',
    MANAGE_TRANSACTIONS: 'FINANCE_MANAGE_TRANSACTIONS',

    // ─── RESTAURANT ADMIN ────────────────────────────────────────────────────
    ADMIN: 'RESTAURANT_ADMIN',
    ADMIN_DASHBOARD: 'RESTAURANT_ADMIN_DASHBOARD',
    ADMIN_POS: 'RESTAURANT_ADMIN_POS',
    ADMIN_PAYMENT_SETTINGS: 'RESTAURANT_ADMIN_PAYMENT_SETTINGS',
    ADMIN_MANAGE_PAYMENT_SETTINGS: 'RESTAURANT_ADMIN_MANAGE_PAYMENT_SETTINGS',
    ADMIN_FINANCE_ANALYSIS: 'RESTAURANT_ADMIN_FINANCE_ANALYSIS',
    ADMIN_SETTINGS: 'RESTAURANT_ADMIN_SETTINGS',
    ADMIN_RBAC: 'RESTAURANT_ADMIN_RBAC',
    ADMIN_MANAGE_RBAC: 'RESTAURANT_ADMIN_MANAGE_RBAC',
    ADMIN_MULTI_OUTLETS: 'RESTAURANT_ADMIN_MULTI_OUTLETS',
    ADMIN_MANAGE_OUTLETS: 'RESTAURANT_ADMIN_MANAGE_OUTLETS',
    ADMIN_KDSKOT: 'RESTAURANT_ADMIN_KDSKOT',
    ADMIN_MANAGE_KOT_KDS_STATIONS_POS: 'RESTAURANT_ADMIN_MANAGE_KOT_KDS_STATIONS_POS',
    ADMIN_AUDIT_LOGS: 'RESTAURANT_ADMIN_AUDIT_LOGS',
    ADMIN_FX_SUPPORT: 'RESTAURANT_ADMIN_FX_SUPPORT',
    ADMIN_INTEGRATION: 'RESTAURANT_ADMIN_INTEGRATION',
    ADMIN_MANAGE_NEWS_FEED: 'RESTAURANT_ADMIN_MANAGE_NEWS_FEED',

} as const;

// Derive a union type → TypeScript will catch any invalid code string at compile time
export type FeatureCode = typeof FEATURE_CODES[keyof typeof FEATURE_CODES];